import { useState } from 'react'
import { t } from 'i18next'
import { IFormModel } from 'types'

/**
 * Form constants
 */
const SEARCH = 'search'
const GRADE_LEVEL = 'grade_level'
const ACADEMIC_YEAR = 'academic_year'
const MENTOR = 'mentor'

/**
 * Form model
 */
const formModel = (): IFormModel  => {
  return {
    [SEARCH]: {
      label: `${t('common.search-table')}`,
      name: SEARCH,
    },
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
    },
    [ACADEMIC_YEAR]: {
      label: `${t('common.academic-year')}`,
      name: ACADEMIC_YEAR,
    },
    [MENTOR]: {
      label: `${t('common.mentor')}`,
      name: MENTOR,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SEARCH]: '',
  [GRADE_LEVEL]: null, // single select
  [ACADEMIC_YEAR]: null, // single select
  [MENTOR]: null, // single select
}

/**
 * Form state
 */
export const useParams = () => {
  const [params, setParams] = useState(initialValues)

  return { params, setParams }
}

export default formModel
